module.exports = "<div class=\"locations-selector-component\">\n\n</div>";